/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessListEducationJourneyProgramStatusResponse } from '../models/SuccessListEducationJourneyProgramStatusResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EducationControllerService {

    /**
     * Returns a list of education journey program statuses for the authenticated user
     * @returns SuccessListEducationJourneyProgramStatusResponse OK
     * @throws ApiError
     */
    public static getEducationJourneys(): CancelablePromise<SuccessListEducationJourneyProgramStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/education/journeys',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
